import { useNavigate } from 'react-router-dom';
import { GlobalButton, NavigateLinks, Authorize } from '@/components';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { Add as AddIcon } from '@mui/icons-material';
import { AssignmentsTable, SearchBar } from './components';
import { useMemo } from 'react';
import { childrenInventoryPageBreadcrumbs } from '../../config';
import { useAssignmentsFilter } from './hooks';
import { ROLES } from '@/components/security/AppRoles';

import styles from './Assignments.module.css';

const Assignments = () => {
  const navigate = useNavigate();
  const breadcrumbs = useMemo(
    () => childrenInventoryPageBreadcrumbs(navigate),
    []
  );
  const { filter, setFilter } = useAssignmentsFilter();
  

  const onSearch = (userId: string) => {
    setFilter({ ...filter, userId: userId ? [userId] : [] });
  };

  return (
    <section className={styles.container}>
      <NavigateLinks actualPage='Asignaciones' breadcrumbs={breadcrumbs} />
      <Authorize permission={ROLES.INVENTORY.admin}>
        <div className={styles.actions}>
          <GlobalButton
            variant={GlobalButtonVariant.primaryButton}
            action={() => navigate('create')}
          >
            <AddIcon />
            Agregar asignación
          </GlobalButton>
        </div>
      </Authorize>
      <SearchBar
        searchValue={Array.isArray(filter.userId) ? (filter.userId[0] || '') : (filter.userId || '')}
        onSearch={onSearch}
      />
      <AssignmentsTable assignmentsFilter={filter} />
    </section>
  );
};

export default Assignments;
